import { Unit } from "src/quantity";
// import { Translations, UnitsLocale } from "./locale";

// export const translations: Translations = {
export const translations = {
  // 基础操作与选择相关
  select: "选择",
  selection: "选择项",
  junction: "节点",
  pipe: "管道",
  reservoir: "蓄水池",

  // 绘制提示
  hintPipeDrawStart: "点击开始绘制管道，然后点击添加每个顶点",
  hintPipeDrawEnd: "双击或按Enter键结束管道绘制",

  // 菜单与帮助
  keyboardShortcuts: "键盘快捷键",
  help: "帮助",
  helpCenter: "帮助中心",
  exit: "退出",
  clearSelection: "清除选择",
  selectAll: "全选",
  undo: "撤销",
  redo: "重做",
  cheatsheet: "速查表",

  // 属性相关
  diameter: "直径",
  length: "长度",
  demand: "需水量",
  baseDemand: "基准需水量",
  actualDemand: "实际需水量",
  elevation: "高程",
  roughness: "粗糙度",
  minorLoss: "局部水头损失系数",
  property: "属性",
  properties: "属性",
  value: "值",
  values: "值",
  status: "状态",
  open: "打开",
  closed: "关闭",

  // 管道状态
  "pipe.open": "打开",
  "pipe.closed": "关闭",

  // 水泵状态
  "pump.on": "运行中",
  "pump.off": "已关闭",
  "pump.off.cannot-deliver-head": "关闭 - 无法提供水头",
  "pump.on.cannot-deliver-flow": "运行中 - 超过最大流量",

  // 阀门状态
  "valve.open.cannot-deliver-pressure": "打开 - 无法提供压力",
  "valve.open.cannot-deliver-flow": "打开 - 无法提供流量",
  "valve.open": "打开",
  "valve.closed": "关闭",
  "valve.active": "激活",

  // 阀门类型
  "valve.prv": "减压阀",
  "valve.psv": "持压阀",
  "valve.fcv": "流量控制阀",
  "valve.pbv": "压力破坏阀",
  "valve.tcv": "节流控制阀",
  "valve.prv.detailed": "减压阀 (PRV: Pressure Reducing Valve)",
  "valve.psv.detailed": "持压阀 (PSV: Pressure Sustaining Valve)",
  "valve.fcv.detailed": "流量控制阀 (FCV: Flow Control Valve)",
  "valve.pbv.detailed": "压力破坏阀 (PBV: Pressure Breaker Valve)",
  "valve.tcv.detailed": "节流控制阀 (TCV: Throttle Control Valve)",
  valveStatus: "阀门状态",
  initialStatus: "初始状态",

  // 水力参数
  head: "水头",
  pumpType: "水泵类型",
  pumpHead: "水泵水头",

  // 模拟相关
  cloudSimulate: "云端仿真",
  simulate: "模拟",
  simulation: "模拟",
  simulationReport: "模拟报告",
  simulationReadyToRun: "准备运行",
  simulationRunning: "运行中...",
  simulationSuccess: "模拟成功",
  simulationWarning: "模拟有警告",
  simulationWarningExplain: "模拟已完成，但存在一个或多个警告。请查看模拟报告了解详情。",
  simulationFailure: "模拟出错",
  simulationFailureExplain: "模拟运行失败。请查看模拟报告了解详情。",
  simulationTook: "模拟耗时 ${1} 秒。",
  simulationOutdated: "模拟已过时",
  runningSimulation: "正在运行模拟...",
  notAvailable: "不可用",

  // 水力结果
  pressure: "压力",
  pressures: "压力值",
  flow: "流量",
  flows: "流量值",
  velocity: "流速",
  velocities: "流速值",

  // 资产相关
  asset: "资产",
  assets: "资产",
  none: "无",
  type: "类型",
  delete: "删除",
  zoomTo: "缩放至",

  // 统计相关
  min: "最小值",
  max: "最大值",
  mean: "平均值",
  sum: "总和",

  // 文件操作
  openProject: "打开项目",
  opening: "打开中...",
  export: "导出",
  cancel: "取消",
  failedToOpenModel: "打开模型失败",
  failedToOpenModelDetail: "请确保提供有效的INP文件。",
  understood: "明白了",
  error: "错误",
  save: "保存",
  saveAndContinue: "保存并继续",
  saving: "保存中...",
  saved: "已保存",
  saveAs: "另存为...",
  saveCanceled: "已取消保存",
  menubarFile: "文件",
    // 在现有翻译中添加
  workspace: "工作空间",
  openWorkspace: "打开工作空间",
  projectName: "项目名称",

    // 在翻译文件中添加
  projects: "项目",
  tasks: "任务",
  teams: "团队",
  settings: "设置",
  //comingSoon: "Coming Soon",

  // 在翻译文件中添加
  publicProjects: "公开项目",
  hydroArk:"水磨方舟",
  browsePublicProjects: "浏览公开项目",
  unsavedChanges: "未保存的更改",
  unsavedChangesQuestion: "是否要保存对当前项目所做的更改？",
  discardChanges: "放弃更改",
  shortcuts: "快捷键",

  // 引导提示
  onboardingViewAndEdit: "查看和编辑属性",
  onboardingSelectDrawing: "从菜单中选择绘图工具${1}",
  onboardingDrawReservoir: "在任意位置点击以放置蓄水池。",
  onboardingDrawJunctions: "点击放置节点。",
  onboardingStartPipe: "点击现有节点开始绘制管道，或在任意位置点击以新建节点开始。",
  onboardingStartPipeEmpty: "在任意位置点击开始绘制管道。",
  onboardingCtrlPipe: "按住 ${1} 并点击可结束当前管道并立即开始新管道。",
  onboardingDrawPipe: "点击定义顶点。在节点处结束或双击添加新节点。",
  onboardingStartPump: "点击现有节点开始绘制水泵，或在任意位置点击以新建节点开始。",
  onboardingStartPumpEmpty: "在任意位置点击开始绘制水泵。",
  onboardingCtrlPump: "按住 ${1} 并点击可结束当前水泵并立即开始新水泵。",
  onboardingDrawPump: "点击定义顶点。在节点处结束或双击添加新节点。",
  onboardingStartValve: "点击现有节点开始绘制阀门，或在任意位置点击以新建节点开始。",
  onboardingStartValveEmpty: "在任意位置点击开始绘制阀门。",
  onboardingCtrlValve: "按住 ${1} 并点击可结束当前阀门并立即开始新阀门。",
  onboardingDrawValve: "点击定义顶点。在节点处结束或双击添加新节点。",
  onboardingSelectAsset: "选择任意资产以查看和修改其属性。",
  onboardingRunningModel: "运行模型并查看结果",
  onboardingRunSimulation: "点击模拟按钮运行水力模拟。",
  onboardingMap: "切换到地图标签页以添加水力结果可视化。",
  onboardingOtherFeatures: "其他实用功能",
  onboardingUndoRedo: "使用 ${1} 和 ${2} 进行撤销或重做。",
  onboardingFiles: "文件操作",
  onboardingMoveNode: "拖动节点可更改其位置。",
  onboardingAutomaticCalculations: "高程和长度会自动分配。",
  onboardingAutomaticUpdates: "高程和长度会自动更新。",
  onboardingAutomaticElevations: "高程会自动分配。",
  onboardingAutomaticLengths: "长度会自动计算。",

  // 单位相关
  unitsSystem: "单位系统",
  units: "单位",
  usCustomaryFlowsExpressed: "美制单位，流量单位为 ${1}",
  siFlowsExpressed: "国际单位制，流量单位为 ${1}",

  // 项目操作
  newProject: "新建项目",
  create: "创建",
  createNew: "新建",
  creating: "创建中...",
  importInp: "导入INP文件",
  importInpToProject: "导入INP",
  selectInpFile: "选择文件",
  dropInp: "拖放INP文件至此打开模型。",
  inpMissing: "无效的文件类型。请使用INP文件。",
  onlyOneInp: "多个INP文件",
  onlyOneInpExplain: "一次仅允许一个INP文件。\n将使用第一个文件。",

  // 保存云端
  "cloudSave.loginRequired": "请先登录",
  "cloudSave.loginRequiredDescription": "保存到云端需要用户登录",
  "cloudSave.projectRequired": "请先打开一个项目",
  "cloudSave.projectRequiredDescription": "需要先打开一个项目才能保存到云端",
  "cloudSave.saveSuccess": "项目已保存到云端",
  "cloudSave.updateSuccess": "项目已更新到云端",
  "cloudSave.saveFailed": "保存失败",
  "cloudSave.saveFailedDescription": "保存到云端时发生错误",
  "cloudSave.branch1Update": "更新现有云端项目",
  "cloudSave.branch2Upload": "本地项目保存到云端",
  "cloudSave.branch3Create": "生成新项目ID并保存到云端",


  "auth.loginRequiredForExport": "请先登录",
  "auth.loginRequiredForExportDescription": "另存导出INP文件，需要用户登录",



  // 水力计算相关
  headlossFormula: "水头损失公式",
  headlossShort: "水头损失",
  headloss: "水头损失",
  autoLengths: "自动计算长度",
  autoElevations: "自动计算高程",
  on: "开启",
  viewReport: "查看报告",
  ignore: "忽略",
  loading: "加载中...",
  ok: "确定",

  // 地图相关
  toggleSatellite: "切换卫星底图",
  welcomePage: "欢迎页面",
  welcomeToEpanetJs: "欢迎使用 百川清云 • QWater！",
  welcomeIntro: "我们正在创建一种新的方式来构建和运行水力模型——直接在浏览器中，通过现代化的、基于Web的EPANET平台。无需安装任何软件，即可在计算机上快速打开、编辑和分析您的管网。所有模拟均在您的设备上运行，确保数据隐私——无需云服务。",
  welcomeNewHere: "新用户？查看我们的 ${1}，几分钟内即可了解基础知识！",
  welcomeExploreWithSamples: "通过打开示例管网探索应用",
  welcomeBuildAndDevelop: "构建与开发",
  quickStartTutorial: "快速入门指南",
  gettingStarted: "入门指南",
  demoUKStyleDescription: "英国风格管网，使用公制单位，流量单位为升/秒。",
  demoUSStyleDescription: "北美风格管网，使用美制单位，流量单位为加仑/分钟。",
  alwaysShowAtStart: "启动时始终显示",
  termsAndConditions: "条款和条件",
  privacyPolicy: "隐私政策",
  downloadFailed: "下载失败",
  checkConnectionAndTry: "请检查网络连接后重试。",
  geocodingNotSupported: "不支持的地理编码",
  geocodingNotSupportedDetail: "您的INP文件包含使用尚不支持的投影系统的坐标或顶点。请确保所有资产均使用WGS84标准进行地理编码。",
  missingCoordinates: "缺少坐标",
  missingCoordinatesDetail: "您的INP文件缺少必要的坐标。请确保所有资产均包含使用WGS84标准的地理编码信息。",
  inpNotFullySupported: "您的INP文件未被完全支持",
  inpNotFullySupportedDetail: "您的INP文件中的某些功能尚未完全支持，可能会影响结果。",
  newFeaturesEveryDay: "我们持续添加新功能和改进！订阅我们的新闻通讯，了解最新更新！",
  subscribeForUpdates: "订阅更新",
  seeDemoNetworks: "查看示例管网",
  issuesSummary: "问题摘要",
  useOfUnsupported: "使用不支持的部分",
  nonDefaultEpanetValues: "检测到非默认的EPANET ${1}值",
  customValueNotSupport: "不支持自定义${1}（使用${2}）",
  ignoredValuesDetected: "检测到被忽略的${1}值",
  valueIgnored: "${1}值被忽略（使用${2}）",
  nodesMissingCoordinates: "节点缺少坐标",
  andXMore: "及${1}个更多...",
  alertInpOutput: "可能会丢失一些数据",
  alertInpOutputSubtitle: "您的INP文件是使用其他应用程序创建的。",
  alertInpOutputDetail: "请注意，某些部分和设置的格式可能不同或被省略。建议您保存副本，而非覆盖原始内容。",

  // 标签与账户
  label: "标签",
  login: "登录",
  register: "注册",
  openSource: "开源",

  // 管网组成
  nodes: "节点",
  node: "节点",
  links: "连接",
  link: "连接",
  layers: "图层",
  checkoutProjectionTool: "您可以使用EPANET投影转换器工具将INP文件投影到WGS84系统。",
  signUpToUnlockResolution: "注册以解锁高分辨率卫星图像。",
  continueWithLowResolution: "继续使用低分辨率",
  oopsSomethingWrong: "哎呀！出了点问题。",
  errorProcessingRequest: "发生了意外错误。",
  pleaseTryAgain: "请重试，如果问题持续，请发送电子邮件至",
  reloadPage: "重新加载页面",
  addCustom: "添加自定义",
  chooseType: "选择类型",
  toggleVisibility: "切换可见性",
  toggleLabelsVisibility: "切换标签可见性",
  basemap: "底图",
  back: "返回",
  updateLayer: "更新图层",
  addLayer: "添加图层",
  name: "名称",
  xyzURLContain: "XYZ URL应包含{z}、{x}和{Y}。",
  supports: "支持",
  checkMapboxDocs: "参见Mapbox文档中的",
  here: "此处",
  accessToken: "访问令牌",

  // 订阅计划
  upgradeYourAccount: "升级您的账户",
  upgrade: "升级",
  planExplain: "${1}计划",
  "plan.pro": "专业版",
  "plan.free": "免费版",
  "plan.education": "教育版",
  "plan.personal": "个人版",
  for: "适用",
  commercialUse: "商业用途",
  nonCommercialUse: "非商业用途",
  monthly: "每月",
  yearlyWithDiscount: "每年 - 节省高达${1}%",
  studentOrPersonal: "学生或个人使用？点击切换！",
  "free.forBetterModelling": "为了更好的建模体验",
  "free.webBasedEpanet": "基于Web的EPANET模型",
  "free.backgroundMap": "背景地图和卫星图像",
  "free.elevations": "自动高程",
  "free.noLimits": "无大小限制",
  "free.communitySupport": "社区支持",
  currentPlan: "当前计划",
  everythingAnd: "包含${1}的所有功能，以及",
  everythingInForFree: "包含${1}的所有功能，完全免费！",
  professionalSupport: "专业支持",
  customMapLayers: "自定义地图图层",
  scenarios: "场景",
  cloudStorage: "云存储",
  pointInTimeRestore: "时间点恢复 - ${1}天",
  demandsAnalysis: "需水量分析",
  liveDataCompare: "实时数据比较",
  monthShort: "月",
  year: "年",
  upgradeTo: "升级至${1}",
  comingSoon: "即将推出",
  individualNamedLicense: "个人命名许可",
  floatingSharedLicenses: "浮动共享许可",
  mostPopular: "最受欢迎",
  minimumTwoLicenses: "至少2个许可",
  teamStorage: "团队存储",
  prioritySupport: "优先支持",
  sharingModels: "模型共享",
  volumeDiscounts: "批量折扣",
  tryItYourself: "亲自尝试",
  learnWithEpanetJS: "通过epanet-js学习",
  learnMore: "了解更多。",
  useStudentEmail: "使用学生邮箱",
  layerAdded: "图层已添加",
  addingLayer: "添加图层中...",
  layerUpdated: "图层已更新",
  updatingLayer: "更新图层中...",
  havingIssuesWithStudentEmail: "验证邮箱遇到问题？",
  getHelp: "获取帮助",

  // 水泵与阀门属性
  startNode: "起点节点",
  endNode: "终点节点",
  pump: "水泵",
  designHead: "设计水头",
  designFlow: "设计流量",
  power: "功率",
  definitionType: "定义类型",
  constantPower: "恒定功率",
  flowVsHead: "流量与水头",
  speed: "转速",
  pumpStatus: "水泵状态",
  valve: "阀门",
  setting: "设置",
  valveType: "阀门类型",
  fixedStatus: "固定状态",

  // 数据验证
  rampShouldBeAscending: "渐变输入值需要按升序排列。",
  notEnoughData: "数据不足。",
  updated: "已更新",
  unableToUpdate: "无法更新",
  invalidRange: "无效范围",
  fixRangeToApply: "请调整范围以应用更改。",
  flowAbs: "流量（绝对值）",
  regenerate: "重新生成",

  // 可视化设置
  mode: "模式",
  classes: "类别",
  colorRamp: "颜色渐变",
  continuousRamp: "连续渐变",
  divergingRamp: "发散渐变",
  reverseColors: "反转颜色",
  addBreak: "添加断点",
  equalIntervals: "等间隔",
  equalQuantiles: "等分位数",
  manual: "手动",
  prettyBreaks: "优化断点",
  naturalBreaksCkMeans: "自然断点（ckmeans）",
  unitHeadloss: "单位水头损失",
  showLabels: "显示标签",
  map: "地图",
  colorBy: "按颜色区分",
  range: "范围",
  ramp: "渐变",
  labels: "标签",
  nodeSymbology: "节点符号",
  linkSymbology: "连接符号",
  ckmeans: "聚类算法",

  // 模拟设置
  simulationSettings: "模拟设置",
  demandMultiplier: "需水量乘数",
  saveAndRun: "保存并运行",

  // 错误提示
  failedToFetchElevation: "获取高程失败",
  failedToFetchElevationExplain: "无法获取高程数据，将赋值为0。",
  elevationNotAvailable: "高程不可用",
  elevationNotAvailableExplain: "无法获取该点的高程。将使用0代替。",
  noInternet: "无网络连接",
  noInternetExplain: "某些功能可能无法使用。",
  connectionRestored: "连接已恢复！",
  mapOfflineMode: "地图离线模式",
  mapOfflineModeExplain: "应用程序现在使用空白背景。",
  failedToLoad: "加载失败",
  failedToLoadTileJSON: "TileJSON图层加载失败。瓦片服务器可能已关闭",
  headsUpSmallScreen: "注意！未针对小屏幕优化",
  smallScreenExplain: "您似乎正在使用较小的设备访问应用。此应用目前在该屏幕尺寸下处于预览模式，某些编辑功能可能不可用。",
  hereYourOptions: "您的选项如下",
  continueAnyway: "继续使用",
  continueAnywayExplain: "您可以继续使用，但体验可能不理想，部分功能可能缺失。",
  watchQuickDemo: "观看快速演示",
  watchQuickDemoExplain: "查看简短演示，了解桌面端的完整应用体验。",
  visitLandingPage: "访问我们的着陆页",
  visitLandingPageExplain: "了解更多关于该应用及其功能的信息。",
  file: "文件",
  somethingWentWrong: "出了点问题",
  tryAgainOrSupport: "请重试，如果错误持续，请联系支持人员。",
  planChangesFromSupport: "计划变更需要支持",
  planChangesFromSupportExplain: "请联系我们的支持团队以修改您的订阅。",
  upgradeSuccessful: "升级成功！",
  upgradeSuccessfulExplain: "感谢您的升级 — 您的新功能现已解锁。",

  // 工作空间相关
  allProjects: "全部项目",
  myProjects: "我的项目",
  teamProjects: "团队项目",
  favorites: "收藏夹",
  searchProjects: "搜索项目...",
  // projectName: "项目名称",
  lastModified: "最后修改",
  views: "查看次数",
  actions: "操作",
  team: "团队",
  personal: "个人",
  createProject: "创建项目",
  projectsFound: "找到 ${1} 个项目",
  compressionRatio: "压缩比",
  unknown: "未知",
  // openProject: "打开项目",
  // delete: "删除",
  // error: "错误",
  // reloadPage: "重新加载",
  noProjectsFound: "未找到项目",
  justNow: "刚刚",
  minutesAgo: "${1} 分钟前",
  hoursAgo: "${1} 小时前",
  daysAgo: "${1} 天前",
  weeksAgo: "${1} 周前",           // 添加这行
  monthsAgo: "${1} 个月前",        // 添加这行
  invalidDate: "无效日期",         // 添加这行
  private: "私有",
  public: "公开",
  copies: "复制",

  // projects: "项目",
  // tasks: "任务",
  // teams: "团队",
  // settings: "设置",
  // type: "类型"

  // lastModified: "最后修改",
  // name: "名称",
  dateCreated: "创建日期",
  viewCount: "查看次数",

  noProjectsYet: "暂无项目",
  createFirstProject: "创建你的第一个水网项目以开始使用",
  // createProject: "创建项目",

  language: "语言",
  saveToCloud: "保存(@)",

  // 水流播放动画
  flowAnimation: "流速动画",
  flowAnimationTooltip: "切换水流流动动画",
  playAnimation: "播放动画",
  pauseAnimation: "暂停动画",
  animationSpeed: "动画速度",
  flowSpeedHigh: "高流速",
  flowSpeedMedium: "中流速",
  flowSpeedLow: "低流速",

  // 资产面板
  enterFullscreen: "进入全屏",
  exitFullscreen: "退出全屏",
  expandPanel: "展开面板",
  collapsePanel: "折叠面板",
  closePanel: "关闭面板",

  // 文件操作
  fileOperations: "新建项目或导入INP文件",
  loadFromLocal: "从本地加载",
  loadFromExamples: "从样例加载",
  dragDropInpFile: "拖拽EPANET的INP文件到这里",
  orBrowseFiles: "或浏览文件",
  clientSideNotice: " *QingChuan·QWater* 是一个客户端应用程序，没有服务器后端。数据仅存储在您的电脑/浏览器上。不会发送任何信息或地图数据到任何服务器。",
  noDataQuestion: "没有数据？",
  trySampleData: "尝试样例数据"

};

export const units: Record<Exclude<Unit, null>, string> = {
  m: "米",
  mm: "毫米",
  in: "英寸",
  ft: "英尺",
  "l/s": "升/秒",
  "l/h": "升/小时",
  km: "千米",
  "gal/min": "加仑/分钟",
  psi: "磅/平方英寸",
  mwc: "米水柱",
  "m/s": "米/秒",
  "m^3": "立方米",
  "ft^3": "立方英尺",
  "ft/s": "英尺/秒",
  "ft^3/s": "立方英尺/秒",
  "l/min": "升/分钟",
  "Mgal/d": "百万加仑/天",
  "IMgal/d": "百万英制加仑/天",
  "Ml/d": "百万升/天",
  "m^3/h": "立方米/小时",
  "m^3/d": "立方米/天",
  "acft/d": "英亩-英尺/天",
  hp: "马力",
  kW: "千瓦",
  "m/km": "米/千米",
  "ft/kft": "英尺/千英尺"
};
